<div class="fixed top-4 right-4 z-100 flex flex-col gap-2 md:gap-3 max-w-sm">
  @for (toast of toastService.allToasts(); track toast.id) {
    <div
      [class]="getToastClasses(toast.type)"
      class="flex items-center gap-3 p-4 rounded-sm border-2 border-secondary shadow-[3px_3px_0_0_var(--color-secondary)] animate-slide-in-right"
    >
      <ng-icon [name]="getIcon(toast.type)" size="1.5rem" class="shrink-0"></ng-icon>
      <p class="flex-1 text-sm md:text-base font-medium">{{ toast.message }}</p>
      <button
        (click)="toastService.remove(toast.id)"
        class="shrink-0 hover:opacity-70 transition-opacity"
      >
        <ng-icon name="heroXMark" size="1.25rem"></ng-icon>
      </button>
    </div>
  }
</div>
